/* =============================================================================
   PILLOW CLUB — Aperçu de broderie
   Moteur autonome, sans dépendance. Expose global.PillowClubBroderie.

   Pourquoi du canvas et pas un filtre SVG :
   1. l'aperçu affiché et le PNG joint à la commande sortent du MÊME code, donc
      le client reçoit exactement ce qu'il a validé ;
   2. le grain du fil, l'éclairage rasant et les points de satin se calculent
      pixel par pixel — un filtre SVG ne sait pas les produire.
   ========================================================================== */
(function (global) {
  'use strict';

  /* ---------------------------------------------------------------- Réglages */

  var MAX_CARACTERES = 14;
  var SEUIL_TRAIT_MM = 1.2;   // en deçà, une machine à broder ne pique plus rien

  /* Ce que l'atelier sait broder, pas ce qu'on imagine : lettres accentuées,
     chiffres (une date), et la ponctuation courante d'un texte court —
     « Mr. », « A & L », « 14.06.2025 ». La liste s'était retrouvée plus
     étroite que la promesse faite au client, qui annonçait les chiffres. */
  var MOTIF_LATIN = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 '’.,&-]*$/;

  /* Teintes relevées sur les photos de la marque, pas choisies à l'œil :
     le rouge brique et le rose sont ceux qu'on voit sur tout le site. Un
     nuancier qui ne contiendrait pas ce qu'on montre serait un piège. */
  var FILS = {
    rouge:  { nom: 'Rouge',   base: '#9B3E33', reflet: '#C87A6B', metallique: false },
    rose:   { nom: 'Rose',    base: '#BE7466', reflet: '#DCA396', metallique: false },
    encre:  { nom: 'Encre',   base: '#121212', reflet: '#4A4A4A', metallique: false },
    blanc:  { nom: 'Blanc',   base: '#F5F3EF', reflet: '#FFFFFF', metallique: false },
    ecru:   { nom: 'Écru',    base: '#E8DFCF', reflet: '#FAF5EC', metallique: false },
    gris:   { nom: 'Gris',    base: '#8C8C86', reflet: '#B4B4AE', metallique: false }
  };





  /* « finesse » = épaisseur du trait le plus fin, en fraction du corps.
     Sert à prévenir quand un texte long descend sous le seuil brodable. */
  var STYLES = [
    { id: 'script',    nom: 'Script',             police: 'Petit Formal Script', repli: 'cursive',    graisse: 400, approche: 0.01, finesse: 0.042, casse: null  },
    { id: 'capitales', nom: 'Capitales espacées', police: 'DM Sans',   repli: 'sans-serif', graisse: 600, approche: 0.22, finesse: 0.082, casse: 'maj' }
  ];

  /* Emplacements autorisés — la liste est volontairement courte.
     Le CENTRE porte les phrases : c'est là qu'on les lit quand on regarde le
     lit. Les deux ANGLES HAUTS portent les textes courts — « Mr. », « Mrs. »,
     des initiales — et se répondent quand on compose un duo. Le bas de la
     taie est exclu : il disparaît sous la couette dès que le lit est fait. */
  var EMPLACEMENTS = {
    'panneau':     'Au centre',
    'haut-gauche': 'En haut à gauche',
    'haut-droit':  'En haut à droite'
  };

  /* ------------------------------------------------------------------ Bruit */
  /* Bruit de valeur déterministe : à état identique, image identique.
     C'est ce qui garantit que le PNG de la commande est reproductible. */

  function melange(x, y, graine) {
    var n = x * 374761393 + y * 668265263 + graine * 1274126177;
    n = (n ^ (n >> 13)) >>> 0;
    n = (n * 1274126177) >>> 0;
    return ((n ^ (n >> 16)) >>> 0) / 4294967295;
  }

  function bruitValeur(x, y, graine) {
    var xi = Math.floor(x), yi = Math.floor(y);
    var xf = x - xi, yf = y - yi;
    var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    var a = melange(xi, yi, graine),     b = melange(xi + 1, yi, graine);
    var c = melange(xi, yi + 1, graine), d = melange(xi + 1, yi + 1, graine);
    return (a * (1 - u) + b * u) * (1 - v) + (c * (1 - u) + d * u) * v;
  }

  /* ------------------------------------------------------------- Utilitaires */

  function versRvb(hex) {
    return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
  }

  /* Flou boîte séparable sur un seul canal — assez rapide pour du temps réel. */
  function flouCanal(src, l, h, rayon) {
    var tmp = new Float32Array(l * h), out = new Float32Array(l * h), x, y, i, s, n;
    for (y = 0; y < h; y++) {
      for (x = 0; x < l; x++) {
        s = 0; n = 0;
        for (i = -rayon; i <= rayon; i++) {
          var xx = x + i;
          if (xx >= 0 && xx < l) { s += src[y * l + xx]; n++; }
        }
        tmp[y * l + x] = s / n;
      }
    }
    for (x = 0; x < l; x++) {
      for (y = 0; y < h; y++) {
        s = 0; n = 0;
        for (i = -rayon; i <= rayon; i++) {
          var yy = y + i;
          if (yy >= 0 && yy < h) { s += tmp[yy * l + x]; n++; }
        }
        out[y * l + x] = s / n;
      }
    }
    return out;
  }

  function echantillon(champ, l, h, x, y) {
    if (x < 0 || y < 0 || x >= l - 1 || y >= h - 1) return 0;
    var xi = x | 0, yi = y | 0, xf = x - xi, yf = y - yi, i = yi * l + xi;
    return (champ[i] * (1 - xf) + champ[i + 1] * xf) * (1 - yf) +
           (champ[i + l] * (1 - xf) + champ[i + l + 1] * xf) * yf;
  }

  /* ============================================================== Le moteur */

  function ApercuBroderie(canvas, options) {
    options = options || {};
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.fond = null;                       // HTMLImageElement
    this.ancres = options.ancres || null;   // bloc « emplacements » du modèle
    this.mmParPixel = options.mmParPixel || null;
    this.qualite = options.qualite || 1;    // 1 = écran, 2 = export

    this.etat = {
      texte: '',
      style: 'script',
      fil: 'or',
      emplacement: 'panneau'
    };

    this._cacheMasque = null;
    this._demandeRendu = null;
  }

  /* Le canevas est plafonné : l'effet de broderie est calculé en pixels, donc
     il DOIT l'être à peu près à la résolution où on le regarde. Une photo de
     1933 px affichée à 634 px réduit tout d'un facteur 3 — le relief et les
     points de satin sont moyennés et l'ensemble redevient du texte plat.
     1400 px couvre l'affichage retina d'une colonne de ~700 px. */
  ApercuBroderie.TAILLE_MAX = 1400;

  ApercuBroderie.prototype.definirFond = function (source, tailleMax) {
    var self = this;
    var plafond = tailleMax || ApercuBroderie.TAILLE_MAX;
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        self.fond = img;
        var k = Math.min(1, plafond / img.naturalWidth);
        self.canvas.width  = Math.round(img.naturalWidth  * k);
        self.canvas.height = Math.round(img.naturalHeight * k);
        resolve(img);
      };
      img.onerror = function () { reject(new Error('Image de fond illisible : ' + source)); };
      img.src = source;
    });
  };

  ApercuBroderie.prototype.definirEtat = function (patch) {
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) this.etat[k] = patch[k];
    this._cacheMasque = null;
    return this;
  };

  /* Rendu groupé sur la frame suivante : taper vite au clavier ne déclenche
     qu'un seul rendu par image écran. */
  ApercuBroderie.prototype.rendreBientot = function () {
    var self = this;
    if (this._demandeRendu) return;
    /* Filet : si la frame n'arrive pas (onglet masqué, page en arrière-plan),
       on dessine quand même au bout de 120 ms. Sans ça, l'aperçu peut rester
       vide indéfiniment alors que tout est prêt. */
    var relais = setTimeout(function () {
      if (self._demandeRendu) { cancelAnimationFrame(self._demandeRendu); self._demandeRendu = null; self.rendre(); }
    }, 120);
    this._demandeRendu = requestAnimationFrame(function () {
      clearTimeout(relais);
      self._demandeRendu = null;
      self.rendre();
      // La police du style courant est-elle réellement disponible pour CE texte ?
      // Sinon on la charge et on redessine : l'aperçu ne doit jamais rester
      // figé sur une police de repli, sans quoi le PNG de la commande serait faux.
      self.assurerPolice().then(function (aChange) { if (aChange) self.rendre(); });
    });
  };

  /* Résout à true si un chargement a effectivement eu lieu (donc redessin utile). */
  ApercuBroderie.prototype.assurerPolice = function () {
    var s = this.styleActif();
    var t = this._texteAffiche();
    if (!t) return Promise.resolve(false);
    var spec = s.graisse + ' 64px ' + JSON.stringify(s.police);
    if (global.document && document.fonts && document.fonts.check(spec, t)) return Promise.resolve(false);
    return chargerPolice(s.police, s.graisse, t).then(function () { return true; });
  };

  ApercuBroderie.prototype.styleActif = function () {
    var liste = STYLES;
    for (var i = 0; i < liste.length; i++) if (liste[i].id === this.etat.style) return liste[i];
    return liste[0];
  };

  ApercuBroderie.prototype.ancreActive = function () {
    if (!this.ancres) return null;
    return this.ancres[this.etat.emplacement] || this.ancres['panneau'] || null;
  };

  /* --------------------------------------------------- Mesure & avertissement */

  ApercuBroderie.prototype.mesurer = function () {
    var ancre = this.ancreActive();
    if (!ancre || !this.fond) return null;

    var L = this.canvas.width, H = this.canvas.height;
    var style = this.styleActif();
    var texte = this._texteAffiche();
    if (!texte) return null;

    var largeurMax = ancre.largeurMax * L;
    var corps = ancre.hauteur * H / 0.72;   // hauteur de capitale -> corps

    var c = document.createElement('canvas').getContext('2d');
    var appliquer = function (t) {
      c.font = style.graisse + ' ' + t + 'px ' + JSON.stringify(style.police) + ', ' + style.repli;
    };
    appliquer(corps);
    var largeur = c.measureText(texte).width + style.approche * corps * (texte.length - 1);

    // Le texte déborde : on réduit le corps jusqu'à ce qu'il tienne.
    if (largeur > largeurMax) {
      corps *= largeurMax / largeur;
      appliquer(corps);
      largeur = c.measureText(texte).width + style.approche * corps * (texte.length - 1);
    }

    var traitMm = null;
    if (this.mmParPixel) traitMm = corps * style.finesse * this.mmParPixel;

    return {
      corps: corps,
      largeur: largeur,
      reduit: corps < ancre.hauteur * H / 0.72 - 0.5,
      traitMm: traitMm,
      brodable: traitMm === null || traitMm >= SEUIL_TRAIT_MM
    };
  };

  ApercuBroderie.prototype._texteAffiche = function () {
    var t = (this.etat.texte || '').trim();
    var style = this.styleActif();
    if (style.casse === 'maj') t = t.toLocaleUpperCase('fr-FR');
    return t;
  };

  /* ------------------------------------------------------ Fabrique la broderie */
  /* Retourne un canvas hors écran contenant le texte transformé en fil. */

  ApercuBroderie.prototype._fabriquerBroderie = function (mesure) {
    var style = this.styleActif();
    var fil = FILS[this.etat.fil] || FILS.or;
    var texte = this._texteAffiche();
    var q = this.qualite;

    var marge = Math.ceil(mesure.corps * 0.45);
    var l = Math.ceil((mesure.largeur + marge * 2) * q);
    var h = Math.ceil((mesure.corps * 1.9 + marge * 2) * q);
    if (l < 4 || h < 4) return null;

    /* 1 — masque : le texte en blanc sur transparent, façonné par le navigateur */
    var mc = document.createElement('canvas');
    mc.width = l; mc.height = h;
    var mx = mc.getContext('2d');
    mx.scale(q, q);
    mx.font = style.graisse + ' ' + mesure.corps + 'px ' + JSON.stringify(style.police) + ', ' + style.repli;
    mx.fillStyle = '#fff';
    mx.textBaseline = 'alphabetic';
    mx.textAlign = 'left';
    mx.direction = 'ltr';

    var baseX = marge, baseY = marge + mesure.corps;
    if (style.approche > 0) {
      // L'approche doit être appliquée glyphe par glyphe : canvas ne la gère pas.
      var x = baseX;
      for (var i = 0; i < texte.length; i++) {
        mx.fillText(texte[i], x, baseY);
        x += mx.measureText(texte[i]).width + style.approche * mesure.corps;
      }
    } else {
      mx.fillText(texte, baseX, baseY);
    }

    /* 2 — champ de distance approché, pour le relief et l'orientation des points */
    var donnees = mx.getImageData(0, 0, l, h).data;
    var alpha = new Float32Array(l * h);
    for (var p = 0, n = l * h; p < n; p++) alpha[p] = donnees[p * 4 + 3] / 255;
    var rayon = Math.max(1, Math.round(mesure.corps * 0.030 * q));
    var champ = flouCanal(alpha, l, h, rayon);

    /* 3 — synthèse du fil */
    var sortie = document.createElement('canvas');
    sortie.width = l; sortie.height = h;
    var sx = sortie.getContext('2d');
    var img = sx.createImageData(l, h);
    var px = img.data;

    var base = versRvb(fil.base), refl = versRvb(fil.reflet);

    var ampl = mesure.corps * 0.034 * q;          // amplitude de déformation du contour
    var freqB = 0.55 / (mesure.corps * 0.05 * q); // grain du fil
    var pasPoint = Math.max(3.0, mesure.corps * 0.115 * q); // écart entre points de satin
    var Lx = -0.55, Ly = -0.72, Lz = 0.42;        // lumière rasante, en haut à gauche
    // direction des points : légèrement inclinée, comme une piqûre posée à la main
    var ANGLE_POINT = 78 * Math.PI / 180;
    var DIR_X = Math.cos(ANGLE_POINT), DIR_Y = Math.sin(ANGLE_POINT);
    var GAIN = 1.30;   // compense la moyenne des modulations (voir plus bas)
    var specPuissance = fil.metallique ? 22 : 46;
    /* Le reflet doit être proportionné à la MARGE DE CLARTÉ qui reste sur la
       couleur de base. Sur un fil écru, déjà presque blanc, un spéculaire fort
       sature et donne un aspect chromé — pas du fil, du métal moulé. */
    var lumBase = (0.2126 * base[0] + 0.7152 * base[1] + 0.0722 * base[2]) / 255;
    var marge = 1 - lumBase;
    var specForce = (fil.metallique ? 0.85 : 0.40) * (0.18 + 0.82 * marge);
    var graine = 1;

    for (var y = 0; y < h; y++) {
      for (var x2 = 0; x2 < l; x2++) {
        var idx = y * l + x2;

        // contour irrégulier : on va chercher le masque un peu à côté
        var dx = (bruitValeur(x2 * freqB, y * freqB, graine) - 0.5) * 2 * ampl;
        var dy = (bruitValeur(x2 * freqB, y * freqB, graine + 7) - 0.5) * 2 * ampl;
        var a = echantillon(alpha, l, h, x2 + dx, y + dy);
        if (a <= 0.02) continue;

        // normale déduite du gradient du champ flouté
        var gx = echantillon(champ, l, h, x2 + 1 + dx, y + dy) - echantillon(champ, l, h, x2 - 1 + dx, y + dy);
        var gy = echantillon(champ, l, h, x2 + dx, y + 1 + dy) - echantillon(champ, l, h, x2 + dx, y - 1 + dy);
        var force = mesure.corps * 0.20 * q;
        var nx = -gx * force, ny = -gy * force, nz = 1;
        var inv = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
        nx *= inv; ny *= inv; nz *= inv;

        var ndl = nx * Lx + ny * Ly + nz * Lz;
        if (ndl < 0) ndl = 0;

        /* Points de satin.
           Première version : phase déduite de la tangente du gradient local.
           Défaut fatal — au centre d'un plein le gradient s'annule, la
           direction devient du bruit, et le motif s'efface précisément là où
           il devrait le plus se voir.
           Ici : direction GLOBALE, comme une vraie piqûre satin dont tous les
           points d'un segment sont parallèles. Le motif traverse les pleins
           de part en part et se lit d'un coup d'œil. */
        var phase = (x2 * DIR_X + y * DIR_Y) / pasPoint * Math.PI * 2;
        var point = 0.82 + 0.38 * Math.cos(phase);

        // creux entre deux points : le fil n'est pas un ruban lisse
        var creux = 0.94 + 0.06 * Math.cos(phase * 2 + 1.1);

        // spéculaire : le reflet du fil, marqué sur l'or et l'argent
        var spec = Math.pow(ndl, specPuissance) * specForce * (0.45 + 0.55 * point);

        // irrégularité de teinte du fil
        var teinte = 0.94 + 0.12 * bruitValeur(x2 * freqB * 0.5, y * freqB * 0.5, graine + 13);

                /* Moyenne des modulations ramenée à 1 : sans cette normalisation, chaque
           fil ressort assombri d'environ moitié — le sable vire au gris, l'encre
           au noir plat, et la couleur choisie n'est plus celle qu'on voit. */
        var ombrage = GAIN * (0.72 + 0.56 * ndl) * point * creux * teinte;
        var o = idx * 4;
        px[o]     = Math.min(255, base[0] * ombrage + refl[0] * spec);
        px[o + 1] = Math.min(255, base[1] * ombrage + refl[1] * spec);
        px[o + 2] = Math.min(255, base[2] * ombrage + refl[2] * spec);
        px[o + 3] = Math.min(255, a * 255 * 1.08);
      }
    }
    sx.putImageData(img, 0, 0);

    return { canvas: sortie, marge: marge, largeur: l / q, hauteur: h / q };
  };

  /* --------------------------------------------------------- Pose de la couche */
  /* Une taie à plat est un plan : un seul drawImage suffit. Le front d'une casquette
     est un cylindre — le texte doit suivre la courbe, sinon il flotte au-dessus
     de l'objet au lieu d'y être piqué.
     On découpe alors la couche en tranches verticales et on pose chacune sur un
     arc de cercle, avec sa propre rotation. `arc` est l'angle total en degrés. */

  var TRANCHES = 48;

  function poser(ctx, broderie, dx, dy, arcDeg) {
    var L = broderie.largeur, H = broderie.hauteur;

    if (!arcDeg) {                       // chemin rapide : surface plane
      ctx.drawImage(broderie.canvas, dx, dy, L, H);
      return;
    }

    var arc = arcDeg * Math.PI / 180;
    var R = L / arc;                     // rayon du cylindre déduit de la largeur
    var srcPas = broderie.canvas.width / TRANCHES;
    var dstPas = L / TRANCHES;

    for (var i = 0; i < TRANCHES; i++) {
      var u = (i + 0.5) / TRANCHES - 0.5; // -0.5 .. +0.5
      var theta = u * arc;
      var cx = R * Math.sin(theta);
      var cy = R * (1 - Math.cos(theta));

      ctx.save();
      ctx.translate(dx + L / 2 + cx, dy + cy);
      ctx.rotate(theta);
      // léger recouvrement : sans lui, des coutures blanches apparaissent
      ctx.drawImage(
        broderie.canvas,
        i * srcPas, 0, srcPas + 1, broderie.canvas.height,
        -dstPas / 2, 0, dstPas + 0.75, H
      );
      ctx.restore();
    }
  }

  /* ------------------------------------------------------------------ Rendu */

  ApercuBroderie.prototype.rendre = function () {
    var ctx = this.ctx, L = this.canvas.width, H = this.canvas.height;
    ctx.clearRect(0, 0, L, H);
    if (this.fond) ctx.drawImage(this.fond, 0, 0, L, H);

    var mesure = this.mesurer();
    if (!mesure) return { vide: true };

    var broderie = this._fabriquerBroderie(mesure);
    if (!broderie) return { vide: true };

    var ancre = this.ancreActive();
    var cx = ancre.x * L, cy = ancre.y * H;

    ctx.save();
    ctx.translate(cx, cy);
    if (ancre.rotation) ctx.rotate(ancre.rotation * Math.PI / 180);
    var incl = Math.tan((ancre.inclinaison || 0) * Math.PI / 180);
    var apla = ancre.aplatissement == null ? 1 : ancre.aplatissement;
    ctx.transform(1, 0, incl, apla, 0, 0);

    var dx2 = -broderie.largeur / 2;
    var dy2 = -broderie.marge - mesure.corps * 0.72;
    var arc = ancre.arc || 0;

    /* 1 — le tissu se creuse autour du fil. Sans ce halo, la broderie a l'air
       posée SUR le tissu au lieu d'être piquée DEDANS. C'est le détail qui
       fait basculer la lecture de « typo incrustée » à « broderie ». */
    ctx.save();
    ctx.globalAlpha = 0.22;
    ctx.filter = 'blur(' + Math.max(2, mesure.corps * 0.11) + 'px) brightness(0)';
    poser(ctx, broderie, dx2, dy2, arc);
    ctx.restore();

    /* 2 — ombre portée du relief, serrée et décalée dans l'axe de la lumière */
    ctx.save();
    ctx.globalAlpha = 0.34;
    ctx.filter = 'blur(' + Math.max(1, mesure.corps * 0.020) + 'px) brightness(0)';
    poser(ctx, broderie, dx2 + mesure.corps * 0.022, dy2 + mesure.corps * 0.030, arc);
    ctx.restore();

    poser(ctx, broderie, dx2, dy2, arc);
    ctx.restore();

    return { vide: false, mesure: mesure };
  };

  ApercuBroderie.prototype.exporterPNG = function (type) {
    return this.canvas.toDataURL(type || 'image/png');
  };

  ApercuBroderie.prototype.exporterBlob = function () {
    var self = this;
    return new Promise(function (resolve) { self.canvas.toBlob(resolve, 'image/png', 0.92); });
  };

  /* ------------------------------------------------------------- Validation */

  function valider(texte) {
    var t = (texte || '').trim();
    if (!t) return { ok: false, code: 'vide', message: 'Écrivez ce que vous voulez faire broder.' };

    if (!MOTIF_LATIN.test(t)) {
      return {
        ok: false, code: 'caracteres',
        message: 'Lettres, chiffres, espace et ponctuation simple ( . , & ’ - ) uniquement.'
      };
    }
    if (t.length > MAX_CARACTERES) {
      return { ok: false, code: 'longueur', message: 'Le texte est limité à ' + MAX_CARACTERES + ' caractères.' };
    }
    return { ok: true, valeur: t };
  }

  /* ---------------------------------------------------- Chargement des polices */

  var policesChargees = {};

  /* PIÈGE : document.fonts.load() sans texte utilise une chaîne de test par
     défaut. Les polices sont servies en sous-ensembles Unicode ; si
     l'échantillon ne couvre pas les caractères visés, le navigateur ne
     télécharge RIEN et le rendu retombe silencieusement sur une police
     système — y compris dans le PNG joint à la commande. On passe donc
     toujours un échantillon explicite. */
  var ECHANTILLON = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzÀÉÈÊÇÎÔÛ';

  function chargerPolice(nom, graisse, texte) {
    var cle = nom + '|' + graisse;
    if (policesChargees[cle]) return policesChargees[cle];
    if (!global.document || !document.fonts) return (policesChargees[cle] = Promise.resolve(false));

    policesChargees[cle] = document.fonts
      .load(graisse + ' 64px ' + JSON.stringify(nom), ECHANTILLON + (texte || ''))
      .then(function (f) { return f.length > 0; })
      .catch(function () { return false; });
    return policesChargees[cle];
  }

  function chargerPolices() {
    return Promise.all(STYLES.map(function (s) {
      return chargerPolice(s.police, s.graisse, ECHANTILLON);
    }));
  }

  /* --------------------------------------------- Encodage de l'état commande */
  /* Transporté en propriété masquée « _etat » sur la ligne de commande.
     Il permet à l'atelier de rejouer l'aperçu au pixel près, même si l'envoi
     du PNG a échoué. En base64 sur les OCTETS UTF-8 : btoa() seul ne sait pas
     encoder les accents, et le vieux couple escape/unescape est déprécié. */

  function encoderEtat(objet) {
    var octets = new TextEncoder().encode(JSON.stringify(objet));
    var binaire = '';
    for (var i = 0; i < octets.length; i++) binaire += String.fromCharCode(octets[i]);
    return btoa(binaire);
  }

  function decoderEtat(chaine) {
    var binaire = atob(chaine);
    var octets = new Uint8Array(binaire.length);
    for (var i = 0; i < binaire.length; i++) octets[i] = binaire.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(octets));
  }

  /* ------------------------------------------------------------------ Export */

  global.PillowClubBroderie = {
    encoderEtat: encoderEtat,
    decoderEtat: decoderEtat,
    ApercuBroderie: ApercuBroderie,
    FILS: FILS,
    STYLES: STYLES,
    EMPLACEMENTS: EMPLACEMENTS,
    MAX_CARACTERES: MAX_CARACTERES,
    SEUIL_TRAIT_MM: SEUIL_TRAIT_MM,
    valider: valider,
    chargerPolice: chargerPolice,
    chargerPolices: chargerPolices
  };
})(typeof window !== 'undefined' ? window : this);
